import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import { rem } from 'polished'
import { useMemo } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import NavBarButtonBase from '../NavBarButton/NavBarButtonBase'
import { matchPath, useLocation } from 'react-router'

const Tab = styled(NavBarButtonBase)`
  padding: 0 ${rem(12)};
  height: ${rem(48)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${props => props.theme.font.primary.weight.bold};
  position: relative;
`

const ActiveIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${rem(4)};
  opacity: 1;
  transition: opacity 0.2s;
  width: 100%;
  background-color: ${props => props.theme.palette.brand.primary.normal};

  &[hidden] {
    opacity: 0;
  }
`

const NewBadge = styled.div`
  position: absolute;
  top: ${rem(2)};
  right: 0;
  background-color: ${props => props.theme.palette.messaging.critical.normalBackground};
  color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(1)} ${rem(3)};
  border-radius: ${props => props.theme.borderRadius.L};
  font-weight: ${props => props.theme.font.primary.weight.bold};
  /* This has not been designed to match LuxKit yet, and needs specific values */
  font-size: 10px;
  line-height: 13px;
`

interface Props extends React.ComponentProps<typeof NavBarButtonBase> {
  nav: App.NavItem
  isDropdown?: boolean
}

const NavBarTab = React.forwardRef<HTMLButtonElement, Props>(function NavBarTab(props, ref) {
  const { nav, isDropdown, ...buttonProps } = props
  const location = useLocation()
  const intl = useIntl()
  const isActive = useMemo(() => {
    if (nav.to) {
      return !!matchPath(location.pathname, { path: `/:regionCode${nav.to}` })
    }
  }, [location.pathname, nav.to])

  const newLabelText = intl.formatMessage({
    id: '_2jYquwp3ORw1vKDAJ9x',
    defaultMessage: 'NEW',
    description: 'New badge label for navigation items in the navigation bar',
  })

  return <Tab
    {...buttonProps}
    to={nav.to}
    href={nav.href}
    ref={ref}
  >
    <span>{nav.text}</span>
    {isDropdown && <LineAngleDownIcon />}
    <ActiveIndicator hidden={!isActive} />
    {nav.newLabel && <NewBadge>{newLabelText}</NewBadge>}
  </Tab>
})

export default NavBarTab
